/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { openModal, toggleSpeech } from '../actions';
import whiteTTS from '../assets/accessibility/tts-white.svg';
import blueTTS from '../assets/accessibility/tts-blue.svg';
import whiteBeeline from '../assets/accessibility/beeline-white.svg';
import blueBeeline from '../assets/accessibility/beeline-blue.svg';

const Accessibility = (props) => {
  return (
    <div className="accessibility-container">
      <div
        role="button"
        tabIndex={0}
        className={`accessibility-button ${props.speechEnabled && 'accessibility-selected'}`}
        onClick={() => {
          if (props.speechAlwaysPopup && !props.speechEnabled) { props.openModal('TTS'); }
          props.toggleSpeech();
        }}
      >
        <img src={props.speechEnabled ? whiteBeeline : blueBeeline} alt="beeline" />
        Text to Speech
      </div>
      <div role="button" tabIndex={0} onClick={() => { props.openModal('BeelineReader'); }} className={`accessibility-button ${props.beelineTheme !== 'Off' && 'accessibility-selected'}`}>
        <img src={props.beelineTheme === 'Off' ? blueTTS : whiteTTS} alt="tts" />
        Enhance Text
      </div>
    </div>
  );
};

const mapStateToProps = (state) => (
  {
    toggle: state.modal.clicked,
    auth: state.user.authenticated,
    speechEnabled: state.speech.enabled,
    speechInitialized: state.speech.initialized,
    speechAlwaysPopup: state.speech.alwaysPopup,
    beelineTheme: state.beeline.selected,
  }
);

export default connect(mapStateToProps, { openModal, toggleSpeech })(Accessibility);
